export enum CountryCodesEnum {
  UnitedKingdom = 'GB',
  Bulgaria = 'BG'
}
